<template>
  <div>
    <!-- <Header /> -->

    <div class="flex">
      <SideBar />

      <div
        class="w-[90%] mx-auto lg:w-full lg:mr-10 mt-10 rounded-3xl heightfix"
        style="box-shadow: 0px 2px 30px 0px #01b0f926"
      >
        <!-- desktop -->
        <div class="hidden lg:block h-full">
          <div class="flex h-full w-full">
            <!-- <div
              class="flex flex-col gap-4 lg:w-[50%] 2xl:w-[25%] rounded-3xl overflow-y-auto"
              style="box-shadow: 0px 2px 30px 0px #01b0f926"
            >
              <div class="pt-6 pb-2">
                <p class="text-primary text-center font-bold">Messages</p>
              </div>
              <div
                v-if="loading"
                class="flex items-center justify-center"
                style="height: calc(100vh - 350px) !important"
              >
                <img src="@/assets/newd/loading.gif" alt="" />
              </div>
              <div
                v-else-if="studentList.length > 0 && !loading"
                class="overflow-y-auto rounded-b-3xl lg:rounded-b-none"
              >
                <div
                  v-for="(student, index) in this.studentList"
                  :key="index"
                  class=""
                >
                  <div
                    v-if="student.to_user.username"
                    @click="messageInfo(student)"
                    :class="{
                      'bg-gray-200':
                        this.activeGroup.to_user.username ==
                        student.to_user.username,
                      'bg-white':
                        this.activeGroup.to_user.username !=
                        student.to_user.username,
                    }"
                    class="py-2 px-3 2xl:px-10 text-base lg:text-sm mb-0 hover:bg-gray-200 cursor-pointer flex justify-between items-center"
                  >
                    <div class="flex gap-1 items-center">
                      <div
                        class="w-9 h-9 rounded-full flex items-center justify-center text-white font-bold"
                      >
                        <div v-if="student.profile_image">
                          <img
                            :src="student.profile_image"
                            alt=""
                            class="w-9 h-9 rounded-full border-2 border-white"
                          />
                        </div>
                        <div v-else>
                          <img
                            src="@/assets/new/image.png"
                            alt=""
                            class="w-9 h-9 rounded-full border-2 border-white"
                          />
                        </div>
                      </div>
                      <div class="px-2 capitalize flex flex-col gap-1">
                        <h1 class="">{{ student.to_user.username }}</h1>
                        <p
                          class="text-xs font-normal text-gray-500 line-clamp-1"
                        >
                          message
                        </p>
                      </div>
                    </div>
                    
                    <div>
                      <div
                        v-if="student.unread_user != null"
                        :class="
                          student.unread_message_count < 10
                            ? 'text-[12px]'
                            : 'text-[9px]'
                        "
                        class="p-1 w-5 h-5 text-xs rounded-full border text-[#0085db] font-semibold flex justify-center items-center bg-gray-100"
                      >
                        {{ student.unread_message_count }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                v-else
                class="flex flex-col justify-center"
                style="height: calc(100vh - 350px) !important"
              >
                <p class="flex justify-center">No Data Found</p>
              </div>
            </div> -->
            <!-- v-if="ChatpopUp" -->
            <div
              
              class="bg-[#F0F5F9] h-full w-full rounded-3xl relative lg:w-[70%] 2xl:w-[75%]"
            >
              <div class="absolute w-full left-0 right-0">
                <div class="bg-[#FFFFFF] rounded-2xl m-4 py-2 px-3">
                  <!-- <div class="flex justify-center items-center gap-2">
                    <div class="">
                      <div v-if="this.selectedStudent.profile_image">
                        <img
                          :src="this.selectedStudent.profile_image"
                          alt=""
                          srcset=""
                          class="rounded-full w-6 h-6 mx-auto"
                        />
                      </div>
                      <img
                        v-else
                        src="@/assets/newd/image.png"
                        alt=""
                        srcset=""
                        class="w-6 h-6 object-contain"
                      />
                    </div>
                    <p class="text-center text-primary font-semibold">
                      {{ this.selectedStudent.to_user.username }}
                    </p>
                  </div> -->
                </div>
              </div>

              <div class="h-full w-full px-3 pt-14 pb-16">
                <div class="p-4 h-full overflow-y-auto" id="chatContainer">
                  <div
                    v-for="(message, index) in totalmessage"
                    :key="index"
                    class="my-4 flex flex-col gap-1"
                  >
                    <template v-if="shouldShowDateLabel(index)">
                      <div
                        class="text-center font-semibold text-gray-200 text-xs"
                      >
                        <button
                          class="bg-blue-300 text-white py-1 px-2 rounded-md"
                        >
                          {{ formatDateLabel(message.created_at) }}
                        </button>
                      </div>
                    </template>
                    <div
                      v-if="message?.owner_email"
                      class="flex"
                      :class="[
                        'my-4 flex gap-2 w-full',
                        message.owner_email === this.userInfo.user.email
                          ? 'justify-end'
                          : 'justify-start',
                      ]"
                    >
                      <div
                        class="relative max-w-[350px] text-xs font-mono"
                        :class="[
                          !message.text && message.file
                            ? 'bg-transparent  text-gray-900'
                            : message.owner_email === this.userInfo.user.email
                            ? 'bg-gray-300 text-gray-900 rounded-2xl px-4 py-2 shadow-md break-words rounded-br-sm'
                            : 'bg-gray-200 text-gray-900 rounded-2xl px-4 py-2  shadow-md break-words rounded-bl-sm',
                        ]"
                      >
                        <!-- File Preview -->

                        <div
                          v-if="message.file"
                          class="mt-2 relative group w-fit"
                        >
                          <div
                            v-if="
                              /\.(jpe?g|png|gif|webp|bmp)$/i.test(message.file)
                            "
                            class="relative inline-block w-fit"
                          >
                            <img
                              :src="message.file"
                              class="rounded w-40 shadow cursor-pointer"
                              alt="Image"
                            />
                            <a
                              :href="message.file"
                              :download="
                                message.filename || getFileName(message.file)
                              "
                              target="_blank"
                              class="absolute top-1 right-1 bg-black/70 p-1 rounded-full text-white"
                              title="Download Image"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                class="w-4 h-4 text-white"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                              >
                                <path
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  stroke-width="2"
                                  d="M4 16v2a2 2 0 002 2h12a2 2 0 002-2v-2M7 10l5 5m0 0l5-5m-5 5V4"
                                />
                              </svg>
                            </a>
                          </div>

                          <!-- Video Preview with Always-Visible Download Icon -->
                          <div
                            v-else-if="/\.(mp4|webm|ogg)$/i.test(message.file)"
                            class="relative inline-block w-fit mt-2"
                          >
                            <video
                              :src="message.file"
                              controls
                              class="rounded w-60 shadow"
                            ></video>
                            <a
                              :href="message.file"
                              :download="
                                message.filename || getFileName(message.file)
                              "
                              target="_blank"
                              class="absolute top-1 right-1 bg-black/70 p-1 rounded-full text-white"
                              title="Download Video"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                class="w-4 h-4 text-white"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                              >
                                <path
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  stroke-width="2"
                                  d="M4 16v2a2 2 0 002 2h12a2 2 0 002-2v-2M7 10l5 5m0 0l5-5m-5 5V4"
                                />
                              </svg>
                            </a>
                          </div>

                          <!-- Document or other file types -->
                          <div v-else class="flex items-center gap-2 mt-2">
                            <span class="text-sm text-blue-600 underline">
                              📄
                              {{
                                message.filename || getFileName(message.file)
                              }}
                            </span>
                            <a
                              :href="message.file"
                              :download="
                                message.filename || getFileName(message.file)
                              "
                              target="_blank"
                              class="text-blue-500 hover:text-blue-700"
                              title="Download File"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                class="w-4 h-4 text-black"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                              >
                                <path
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  stroke-width="2"
                                  d="M4 16v2a2 2 0 002 2h12a2 2 0 002-2v-2M7 10l5 5m0 0l5-5m-5 5V4"
                                />
                              </svg>
                            </a>
                          </div>
                        </div>

                        <div>
                          <span v-if="message.text">{{ message.text }}</span>
                          <!-- <span v-else>Na</span> -->
                        </div>

                        <p
                          class="text-[10px] flex justify-end text-[#7e7c7c] font-bold mt-1"
                        >
                          {{ formatDateTime(message.created_at) }}
                        </p>
                        <div
                          v-if="
                            message.owner_email === this.userInfo.user.email &&
                            (message.text || !message.file)
                          "
                          class="absolute right-0 bottom-0 translate-x-full w-0 h-0 border-t-[10px] border-t-transparent border-l-[10px] border-l-[#d1d5db]"
                        ></div>

                        <div
                          v-else-if="
                            message.owner_email !== this.userInfo.user.email &&
                            (message.text || !message.file)
                          "
                          class="absolute left-0 bottom-0 -translate-x-full w-0 h-0 border-t-[10px] border-t-transparent border-r-[10px] border-r-gray-200"
                        ></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="absolute bottom-2 w-full left-0 right-0">
                <div
                  class="bg-[#FFFFFF] rounded-2xl m-4 flex items-center justify-between py-2 px-3 gap-3"
                >
                  <!-- Plus Button -->

                  <div class="relative">
                    <div
                      v-if="showIcons"
                      class="absolute bottom-12 left-0 flex flex-col items-center gap-3 transition-all duration-300 z-10"
                    >
                      <!-- Document Icon -->
                      <div class="relative group">
                        <button
                          @click="triggerInput('document')"
                          class="w-8 h-8 bg-blue-500 text-white rounded-full flex items-center justify-center shadow hover:bg-blue-600"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            class="w-4 h-4"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="2"
                            viewBox="0 0 24 24"
                          >
                            <path
                              d="M7 2h8l5 5v13a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2z"
                            />
                            <path d="M14 2v6h6" />
                          </svg>
                        </button>
                        <span
                          class="absolute left-full top-1/2 ml-2 -translate-y-1/2 bg-gray-800 text-white text-xs px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition"
                        >
                          Document
                        </span>
                      </div>

                      <!-- Image Icon -->
                      <div class="relative group">
                        <button
                          @click="triggerInput('image')"
                          class="w-8 h-8 bg-blue-500 text-white rounded-full flex items-center justify-center shadow hover:bg-blue-600"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            class="w-4 h-4"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="2"
                            viewBox="0 0 24 24"
                          >
                            <rect x="3" y="3" width="18" height="18" rx="2" />
                            <circle cx="8" cy="8" r="1.5" />
                            <path d="M21 15l-5-5L5 21" />
                          </svg>
                        </button>
                        <span
                          class="absolute left-full top-1/2 ml-2 -translate-y-1/2 bg-gray-800 text-white text-xs px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition"
                        >
                          Image
                        </span>
                      </div>

                      <!-- Video Icon -->
                      <div class="relative group">
                        <button
                          @click="triggerInput('video')"
                          class="w-8 h-8 bg-blue-500 text-white rounded-full flex items-center justify-center shadow hover:bg-blue-600"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            class="w-4 h-4"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="2"
                            viewBox="0 0 24 24"
                          >
                            <rect x="3" y="5" width="15" height="14" rx="2" />
                            <path d="M21 7l-5 4v2l5 4V7z" />
                          </svg>
                        </button>
                        <span
                          class="absolute left-full top-1/2 ml-2 -translate-y-1/2 bg-gray-800 text-white text-xs px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition"
                        >
                          Video
                        </span>
                      </div>

                      <input
                        ref="document"
                        type="file"
                        accept=".pdf,.doc,.docx"
                        class="hidden"
                        @change="handleFile('document', $event)"
                      />
                      <input
                        ref="image"
                        type="file"
                        accept="image/*"
                        class="hidden"
                        @change="handleFile('image', $event)"
                      />
                      <input
                        ref="video"
                        type="file"
                        accept="video/*"
                        class="hidden"
                        @change="handleFile('video', $event)"
                      />
                    </div>

                    <!-- Plus Button -->
                    <button
                      @click="toggleIcons"
                      class="w-8 h-8 bg-blue-600 text-white rounded-full flex items-center justify-center hover:bg-blue-700"
                      title="Add"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="w-4 h-4"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M12 4v16m8-8H4"
                        />
                      </svg>
                    </button>
                  </div>

                  <!-- Input + Preview -->
                  <div class="flex flex-col w-full gap-2">
                    <!-- File Preview -->
                    <div
                      v-if="fileData.name"
                      class="w-full px-4 py-2 bg-gray-100 rounded-xl relative mb-1"
                    >
                      <div class="flex justify-between items-start">
                        <div>
                          <p class="text-xs font-semibold mb-1">Preview:</p>

                          <template v-if="fileData.type === 'image'">
                            <img
                              :src="fileData.url"
                              alt="Preview"
                              class="w-40 rounded shadow"
                            />
                          </template>
                          <template v-else-if="fileData.type === 'video'">
                            <video
                              :src="fileData.url"
                              controls
                              class="w-60 rounded shadow"
                            />
                          </template>
                          <template v-else>
                            <p class="text-xs text-gray-700">
                              {{ fileData.name }}
                            </p>
                          </template>
                        </div>
                        <button
                          @click="clearPreview"
                          class="text-red-500 hover:text-red-700 text-sm"
                        >
                          ✕
                        </button>
                      </div>
                    </div>

                    <!-- Text Input -->
                    <input
                      v-model="messageVal"
                      @keyup.enter="sendmsg()"
                      type="text"
                      class="w-full border-none outline-none text-sm text-gray-800"
                      placeholder="Type your text here..."
                    />
                  </div>
                  <button
                    @click="sendmsg()"
                    class="bg-blues w-[30px] h-[30px] rounded-full flex items-center justify-center"
                  >
                    <img src="@/assets/newd/arrow.png" alt="" />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- mobile -->
        <div class="block lg:hidden h-full">
          <div class="flex h-full">
            <!-- <div
              v-if="studentmessage"
              class="flex flex-col gap-4 w-full overflow-y-auto rounded-3xl"
              style="box-shadow: 0px 2px 30px 0px #01b0f926"
            >
              <div class="pt-6 pb-2">
                <p class="text-primary text-center font-bold">Messages</p>
              </div>
              <div
                v-if="loading"
                class="flex items-center justify-center"
                style="height: calc(100vh - 350px) !important"
              >
                <img src="@/assets/newd/loading.gif" alt="" />
              </div>
              <div
                v-else-if="studentList.length > 0 && !loading"
                class="overflow-y-auto"
              >
                <div
                  v-for="(student, index) in this.studentList"
                  :key="index"
                  class=""
                >
                  <div
                    v-if="student.to_user.username"
                    @click="messageInfo(student)"
                    :class="{
                      'bg-gray-200':
                        this.activeGroup.to_user.username ==
                        student.to_user.username,
                      'bg-white':
                        this.activeGroup.to_user.username !=
                        student.to_user.username,
                    }"
                    class="py-3 px-5 text-base lg:text-sm mb-0 hover:bg-gray-200 cursor-pointer flex justify-between items-center"
                  >
                    <div class="flex gap-1 items-center">
                      <div
                        class="w-9 h-9 rounded-full flex items-center justify-center text-white font-bold"
                      >
                        <div v-if="student.profile_image">
                          <img
                            :src="student.profile_image"
                            alt=""
                            class="w-9 h-9 rounded-full border-2 border-white"
                          />
                        </div>
                        <div v-else>
                          <img
                            src="@/assets/new/image.png"
                            alt=""
                            class="w-9 h-9 rounded-full border-2 border-white"
                          />
                        </div>
                      </div>
                      <div class="px-2 capitalize flex flex-col gap-1">
                        <h1 class="">{{ student.to_user.username }}</h1>
                        <p
                          class="text-xs font-normal text-gray-500 line-clamp-1"
                        >
                          message
                        </p>
                      </div>
                    </div>
                    <div class="hidden">
                      <div
                        v-if="student.unread_user != null"
                        :class="
                          student.unread_message_count < 10
                            ? 'text-[12px]'
                            : 'text-[9px]'
                        "
                        class="p-1 w-5 h-5 text-xs rounded-full border text-[#0085db] font-semibold flex justify-center items-center bg-gray-100"
                      >
                        {{ student.unread_message_count }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                v-else
                class="flex flex-col justify-center"
                style="height: calc(100vh - 350px) !important"
              >
                <p class="flex justify-center">No Data Found</p>
              </div>
            </div> -->

            <!--   v-if="ChatpopUp" -->
            <div
            
              class="bg-[#F0F5F9] h-full w-full rounded-3xl relative"
            >
              <div
                class="flex justify-end p-2"
                @click="
                  ChatpopUp = false;
                  studentmessage = true;
                "
              >
                <p
                  class="text-blues rounded-lg text-sm font-semibold underline cursor-pointer"
                >
                  Back
                </p>
              </div>
              <div class="absolute w-full left-0 right-0">
                <div class="bg-[#FFFFFF] rounded-2xl m-4 py-2 px-3">
                  <!-- <div class="flex justify-center items-center gap-2">
                    <div class="">
                      <div v-if="this.selectedStudent.profile_image">
                        <img
                          :src="this.selectedStudent.profile_image"
                          alt=""
                          srcset=""
                          class="rounded-full w-6 h-6 mx-auto"
                        />
                      </div>
                      <img
                        v-else
                        src="@/assets/newd/image.png"
                        alt=""
                        srcset=""
                        class="w-6 h-6 object-contain"
                      />
                    </div>
                    <p class="text-center text-primary font-semibold">
                      {{ this.selectedStudent.to_user.username }}
                    </p>
                  </div> -->
                </div>
              </div>

              <div class="h-full w-full px-3 pt-14 pb-16">
                <div class="p-4 h-full overflow-y-auto" id="chatContainer">
                  <div
                    v-for="(message, index) in totalmessage"
                    :key="index"
                    class="my-4 flex flex-col gap-1"
                  >
                    <template v-if="shouldShowDateLabel(index)">
                      <div
                        class="text-center font-semibold text-gray-200 text-xs"
                      >
                        <button
                          class="bg-blue-300 text-white py-1 px-2 rounded-md"
                        >
                          {{ formatDateLabel(message.created_at) }}
                        </button>
                      </div>
                    </template>
                    <div
                      v-if="message?.owner_email"
                      class="flex"
                      :class="[
                        'my-4 flex gap-2 w-full',
                        message.owner_email === this.userInfo.user.email
                          ? 'justify-end'
                          : 'justify-start',
                      ]"
                    >
                      <div
                        class="relative max-w-[350px] text-xs font-mono"
                        :class="[
                          !message.text && message.file
                            ? 'bg-transparent  text-gray-900'
                            : message.owner_email === this.userInfo.user.email
                            ? 'bg-gray-300 text-gray-900 rounded-2xl px-4 py-2 shadow-md break-words rounded-br-sm'
                            : 'bg-gray-200 text-gray-900 rounded-2xl px-4 py-2  shadow-md break-words rounded-bl-sm',
                        ]"
                      >
                        <!-- File Preview from URL -->

                        <div
                          v-if="message.file"
                          class="mt-2 relative group w-fit"
                        >
                          <div
                            v-if="
                              /\.(jpe?g|png|gif|webp|bmp)$/i.test(message.file)
                            "
                            class="relative inline-block w-fit"
                          >
                            <img
                              :src="message.file"
                              class="rounded w-40 shadow cursor-pointer"
                              alt="Image"
                            />
                            <a
                              :href="message.file"
                              :download="
                                message.filename || getFileName(message.file)
                              "
                              target="_blank"
                              class="absolute top-1 right-1 bg-black/70 p-1 rounded-full text-white"
                              title="Download Image"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                class="w-4 h-4 text-white"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                              >
                                <path
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  stroke-width="2"
                                  d="M4 16v2a2 2 0 002 2h12a2 2 0 002-2v-2M7 10l5 5m0 0l5-5m-5 5V4"
                                />
                              </svg>
                            </a>
                          </div>

                          <!-- Video Preview with Always-Visible Download Icon -->
                          <div
                            v-else-if="/\.(mp4|webm|ogg)$/i.test(message.file)"
                            class="relative inline-block w-fit mt-2"
                          >
                            <video
                              :src="message.file"
                              controls
                              class="rounded w-60 shadow"
                            ></video>
                            <a
                              :href="message.file"
                              :download="
                                message.filename || getFileName(message.file)
                              "
                              target="_blank"
                              class="absolute top-1 right-1 bg-black/70 p-1 rounded-full text-white"
                              title="Download Video"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                class="w-4 h-4 text-white"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                              >
                                <path
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  stroke-width="2"
                                  d="M4 16v2a2 2 0 002 2h12a2 2 0 002-2v-2M7 10l5 5m0 0l5-5m-5 5V4"
                                />
                              </svg>
                            </a>
                          </div>

                          <!-- Document or other file types -->
                          <div v-else class="flex items-center gap-2 mt-2">
                            <span class="text-sm text-blue-600 underline">
                              📄
                              {{
                                message.filename || getFileName(message.file)
                              }}
                            </span>
                            <a
                              :href="message.file"
                              :download="
                                message.filename || getFileName(message.file)
                              "
                              target="_blank"
                              class="text-blue-500 hover:text-blue-700"
                              title="Download File"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                class="w-4 h-4 text-black"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                              >
                                <path
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  stroke-width="2"
                                  d="M4 16v2a2 2 0 002 2h12a2 2 0 002-2v-2M7 10l5 5m0 0l5-5m-5 5V4"
                                />
                              </svg>
                            </a>
                          </div>
                        </div>

                        <div>
                          <span v-if="message.text">{{ message.text }}</span>
                          <!-- <span v-else>Na</span> -->
                        </div>

                        <p
                          class="text-[10px] flex justify-end text-[#7e7c7c] font-bold mt-1"
                        >
                          {{ formatDateTime(message.created_at) }}
                        </p>
                        <div
                          v-if="
                            message.owner_email === this.userInfo.user.email &&
                            (message.text || !message.file)
                          "
                          class="absolute right-0 bottom-0 translate-x-full w-0 h-0 border-t-[10px] border-t-transparent border-l-[10px] border-l-[#d1d5db]"
                        ></div>

                        <div
                          v-else-if="
                            message.owner_email !== this.userInfo.user.email &&
                            (message.text || !message.file)
                          "
                          class="absolute left-0 bottom-0 -translate-x-full w-0 h-0 border-t-[10px] border-t-transparent border-r-[10px] border-r-gray-200"
                        ></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="absolute bottom-2 w-full left-0 right-0">
                <div
                  class="bg-[#FFFFFF] rounded-2xl m-4 flex items-center justify-between py-2 px-3 gap-3"
                >
                  <!-- Plus Button -->

                  <div class="relative">
                    <div
                      v-if="showIcons"
                      class="absolute bottom-12 left-0 flex flex-col items-center gap-3 transition-all duration-300 z-10"
                    >
                      <!-- Document Icon -->
                      <div class="relative group">
                        <button
                          @click="triggerInput('document')"
                          class="w-8 h-8 bg-blue-500 text-white rounded-full flex items-center justify-center shadow hover:bg-blue-600"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            class="w-4 h-4"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="2"
                            viewBox="0 0 24 24"
                          >
                            <path
                              d="M7 2h8l5 5v13a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2z"
                            />
                            <path d="M14 2v6h6" />
                          </svg>
                        </button>
                        <span
                          class="absolute left-full top-1/2 ml-2 -translate-y-1/2 bg-gray-800 text-white text-xs px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition"
                        >
                          Document
                        </span>
                      </div>

                      <!-- Image Icon -->
                      <div class="relative group">
                        <button
                          @click="triggerInput('image')"
                          class="w-8 h-8 bg-blue-500 text-white rounded-full flex items-center justify-center shadow hover:bg-blue-600"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            class="w-4 h-4"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="2"
                            viewBox="0 0 24 24"
                          >
                            <rect x="3" y="3" width="18" height="18" rx="2" />
                            <circle cx="8" cy="8" r="1.5" />
                            <path d="M21 15l-5-5L5 21" />
                          </svg>
                        </button>
                        <span
                          class="absolute left-full top-1/2 ml-2 -translate-y-1/2 bg-gray-800 text-white text-xs px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition"
                        >
                          Image
                        </span>
                      </div>

                      <!-- Video Icon -->
                      <div class="relative group">
                        <button
                          @click="triggerInput('video')"
                          class="w-8 h-8 bg-blue-500 text-white rounded-full flex items-center justify-center shadow hover:bg-blue-600"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            class="w-4 h-4"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="2"
                            viewBox="0 0 24 24"
                          >
                            <rect x="3" y="5" width="15" height="14" rx="2" />
                            <path d="M21 7l-5 4v2l5 4V7z" />
                          </svg>
                        </button>
                        <span
                          class="absolute left-full top-1/2 ml-2 -translate-y-1/2 bg-gray-800 text-white text-xs px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition"
                        >
                          Video
                        </span>
                      </div>

                      <input
                        ref="document"
                        type="file"
                        accept=".pdf,.doc,.docx"
                        class="hidden"
                        @change="handleFile('document', $event)"
                      />
                      <input
                        ref="image"
                        type="file"
                        accept="image/*"
                        class="hidden"
                        @change="handleFile('image', $event)"
                      />
                      <input
                        ref="video"
                        type="file"
                        accept="video/*"
                        class="hidden"
                        @change="handleFile('video', $event)"
                      />
                    </div>

                    <!-- Plus Button -->
                    <button
                      @click="toggleIcons"
                      class="w-8 h-8 bg-blue-600 text-white rounded-full flex items-center justify-center hover:bg-blue-700"
                      title="Add"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="w-4 h-4"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M12 4v16m8-8H4"
                        />
                      </svg>
                    </button>
                  </div>

                  <!-- Input + Preview -->
                  <div class="flex flex-col w-full gap-2">
                    <!-- File Preview -->
                    <div
                      v-if="fileData.name"
                      class="w-full px-4 py-2 bg-gray-100 rounded-xl relative mb-1"
                    >
                      <div class="flex justify-between items-start">
                        <div>
                          <p class="text-xs font-semibold mb-1">Preview:</p>

                          <template v-if="fileData.type === 'image'">
                            <img
                              :src="fileData.url"
                              alt="Preview"
                              class="w-40 rounded shadow"
                            />
                          </template>
                          <template v-else-if="fileData.type === 'video'">
                            <video
                              :src="fileData.url"
                              controls
                              class="w-60 rounded shadow"
                            />
                          </template>
                          <template v-else>
                            <p class="text-xs text-gray-700">
                              {{ fileData.name }}
                            </p>
                          </template>
                        </div>
                        <button
                          @click="clearPreview"
                          class="text-red-500 hover:text-red-700 text-sm"
                        >
                          ✕
                        </button>
                      </div>
                    </div>

                    <!-- Text Input -->
                    <input
                      v-model="messageVal"
                      @keyup.enter="sendmsg()"
                      type="text"
                      class="w-full border-none outline-none text-sm text-gray-800"
                      placeholder="Type your text here..."
                    />
                  </div>
                  <button
                    @click="sendmsg()"
                    class="bg-blues w-[30px] h-[30px] rounded-full flex items-center justify-center"
                  >
                    <img src="@/assets/newd/arrow.png" alt="" />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "@/components/Instructor/Header.vue";
import SideBar from "@/components/Instructor/SideBar.vue";

import axios from "axios";
import { mapGetters } from "vuex";

export default {
  components: {
    Header,
    SideBar,
  },
  data() {
    return {
      messageVal: null,
      totalmessage: [],
      studentList: [],
      selectedStudent: null,
      ChatpopUp: false,

      loading: true,

      activeGroup: null,
      studentmessage: true,
      showIcons: false,
      message_list: null,
      fileData: {
        type: "",
        name: "",
        url: "",
        raw: null,
      },
    };
  },

  async created() {
    await this.getmessage();
    await this.getstudentdetails();
  },

  props: ["course_id", "uuid"],

  computed: {
    ...mapGetters(["userInfo"]),
  },

  mounted() {
    setTimeout(() => {
      let chatContainer = document.getElementById("chatContainer");

      if (chatContainer) {
        console.log("Height::::=", chatContainer.offsetHeight);
        chatContainer.scrollTo({
          top: chatContainer.scrollHeight + 300,
          behavior: "smooth",
        });
      }
    }, 200);
    this.websocket();
  },

  methods: {
    getFileName(filePath) {
      return filePath.split("/").pop();
    },
    triggerInput(type) {
      this.$refs[type].click();
    },
    handleFile(type, event) {
      const file = event.target.files[0];
      if (!file) return;

      this.fileData.name = file.name;
      this.fileData.type = type;
      this.fileData.raw = file;

      if (type === "image" || type === "video") {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.fileData.url = e.target.result;
        };
        reader.readAsDataURL(file);
      } else {
        this.fileData.url = "";
      }

      this.toggleIcons();
    },
    clearPreview() {
      this.fileData = { type: "", name: "", url: "", raw: null };
      ["document", "image", "video"].forEach((type) => {
        if (this.$refs[type]) this.$refs[type].value = "";
      });
    },
    toggleIcons() {
      this.showIcons = !this.showIcons;
    },
    formatDateTime(isoString) {
      const date = new Date(isoString);

      const daysOfWeek = ["Sun", "Mon", "Tues", "Wed", "Thurs", "Fri", "Sat"];
      const dayName = daysOfWeek[date.getDay()];

      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();

      let hours = date.getHours();
      const minutes = String(date.getMinutes()).padStart(2, "0");
      const ampm = hours >= 12 ? "PM" : "AM";

      hours = hours % 12;
      hours = hours ? hours : 12;

      return `${dayName} ${hours}:${minutes} ${ampm}`;
      // Output: Sunday 09/04/2025 5:20 PM
    },

    formatDateLabel(isoString) {
      const date = new Date(isoString);
      const now = new Date();

      const isToday = date.toDateString() === now.toDateString();

      const yesterday = new Date();
      yesterday.setDate(now.getDate() - 1);
      const isYesterday = date.toDateString() === yesterday.toDateString();

      if (isToday) return "Today";
      if (isYesterday) return "Yesterday";

      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();

      return `${day}/${month}/${year}`;
    },

    shouldShowDateLabel(index) {
      if (index === 0) return true;

      const current = this.formatDateLabel(this.totalmessage[index].created_at);
      const previous = this.formatDateLabel(
        this.totalmessage[index - 1].created_at
      );

      return current !== previous;
    },

    scrollToBottomChat() {
      setTimeout(() => {
        console.log("Height::::=", chatContainer.offsetHeight);

        chatContainer.scrollTo({
          top: chatContainer.scrollHeight + 300,
          behavior: "smooth",
        });
      }, 200);
    },

    async getstudentdetails() {
      await axios
        .get(
          `${process.env.VUE_APP_API}/message-room-get/?Key=${this.userInfo.token_key}&course__id=${this.course_id}`
        )
        .then((response) => {
          if (response.data.status == 200) {
            this.studentList = response.data.data;

            // this.messageInfo(); 
            
            console.log("this.studentList check::", this.studentList);

            this.selectedStudent = this.studentList.find((data)=>{
              data.uuid === this.uuid
              // console.log(typeof(data.uuid), typeof(this.uuid), "data::");
            })

            // console.log(":::list:::", this.selectedStudent);

            console.log(this.studentList.find((data)=>{
              data.uuid === this.uuid
              // console.log(typeof(data.uuid), typeof(this.uuid), "data::");
            }))

            if (this.studentList.length > 0) {
              // const firstGroup = this.studentList[0];
              // this.activeGroup = firstGroup.title || "Untitled";
              // 
            }
            setTimeout(() => {
              this.loading = false;
            }, 500);
          } else if (response.data.status == 400) {
            setTimeout(() => {
              this.loading = false;
            }, 500);

            this.studentList = [];
          }
        });
    },

    async getstudentdetailsforwebsocket() {
      await axios
        .get(
          `${process.env.VUE_APP_API}/message-room-get/?Key=${this.userInfo.token_key}&course__id=${this.course_id}`
        )
        .then((response) => {
          if (response.data.status == 200) {
            this.studentList = response.data.data;
            // if (this.studentList.length > 0) {
            //   const firstGroup = this.studentList[0];
            //   this.activeGroup = firstGroup.title || "Untitled";
            //   this.messageInfo(firstGroup);
            // }
            // setTimeout(() => {
            //   this.loading = false;
            // }, 500);
          } else if (response.data.status == 400) {
            setTimeout(() => {
              this.loading = false;
            }, 500);
            this.studentList = [];
          }
        });
    },

    async messageInfo(data) {
      this.activeGroup = data;
      this.ChatpopUp = true;
      this.studentmessage = false;

      // this.websocket(data);

      await this.getmessage(data);
      console.log(":::User data:::", data);

      this.selectedStudent = data;

      // const unreadIds = this.totalmessage
      //   .filter((message) => message.readed === false)
      //   ?.map((item) => item.id);
      // if (unreadIds.length > 0) {
      //   this.getcountread(data);
      // }
      // console.log("unreadIds", unreadIds);
    },
    async getmessage() {
    
      // this.selectedStudent = data;
      // console.log(" this.selectedStudent", this.selectedStudent);

      await axios
        .get(
          `${process.env.VUE_APP_API}/message-chat-retrieve/${this.uuid}/?Key=${this.userInfo.token_key}`
        )
        .then((Response) => {
          if (Response.data.status == 200) {
            this.totalmessage = Response.data.data;
            this.message_list = this.totalmessage.map((msg) => msg.id);
            // console.log("this.totalmessage123", this.message_list);
            console.log("array:::", Response.data.id_list);
            //  this.updateMessage();
            // this.websocket(data);
            if (this.socket && this.socket.readyState === WebSocket.OPEN) {
              const message = {
                type: "mark_as_read",
                message_ids: Response.data.id_list,
              };
              this.socket.send(JSON.stringify(message));
            }
          }
        });
      this.scrollToBottomChat();
    },

    websocket() {
      const groupId = this.uuid;
      const wsUrl = `${process.env.VUE_APP_SOCKET_URL}/ws/private-chat/${groupId}/?Key=${this.userInfo.token_key}`;
      this.socket = new WebSocket(wsUrl);

      console.log("WebSocket created:", this.socket);

      this.socket.onopen = () => {
        console.log(`Connected to group ${groupId}`);
      };

      //  if (this.socket && this.socket.readyState === WebSocket.OPEN) {
      //    const message = {
      //   type:  "mark_as_read",
      //   message_ids: text || "",
      // };
      //   this.socket.send(JSON.stringify(message));
      //   this.messageVal = "";
      //   this.clearPreview();
      // } else {
      //   console.warn("WebSocket is not connected or not open.");
      // }

      this.socket.onmessage = (event) => {
        try {
          if (JSON.parse(event.data).type == "mark_as_read_response") {
          } else {
            const msg = JSON.parse(event.data);
            console.log(msg);
            if (msg.file && msg.file.startsWith("/media/")) {
              const baseURL = `${process.env.VUE_APP_API}`;
              msg.file = baseURL + msg.file;
            }
            this.totalmessage.push(msg);
            // console.log(msg.owner_id, this.activeGroup.to_user.id);
            this.scrollToBottomChat();
          }

          // if(JSON.parse(event.data).type == "mark_as_read_response"){
          //   console.log("trigger from here.");
          //   this.getstudentdetailsforwebsocket();
          // }
          // else{
          //   const msg = JSON.parse(event.data);
          //   console.log(msg);
          //   if (msg.file && msg.file.startsWith("/media/")) {
          //     const baseURL = `${process.env.VUE_APP_API}`;
          //     msg.file = baseURL + msg.file;
          //   }
          //   this.totalmessage.push(msg);
          //   console.log(msg.owner_id, this.activeGroup.to_user.id);
          //   this.scrollToBottomChat();
          //   if(msg.owner_id != this.activeGroup.to_user.id){
          //     this.getstudentdetailsforwebsocket();
          //   }
          //   else if(msg.client_id != this.userInfo.user.id){
          //     this.getstudentdetailsforwebsocket();
          //   }
          //   else{
          //     const message = {
          //       type:  "mark_as_read",
          //       message_ids: [msg.id],
          //     };
          //     this.socket.send(JSON.stringify(message));
          //   }
          // }
        } catch (error) {
          console.error("Error parsing message:", error);
        }
      };

      this.socket.onclose = (event) => {
        console.log("WebSocket closed:", event);
      };

      this.socket.onerror = (error) => {
        console.error("WebSocket error:", error);
      };
    },
    sendmsg() {
      const text = this.messageVal?.trim();

      if (!text && !this.fileData?.name) {
        console.warn("Empty message and no file selected.");
        return;
      }

      const message = {
        username: this.userInfo.user.email,
        text: text || "",
      };

      if (this.fileData.name) {
        message.filename = this.fileData.name;

        if (this.fileData.url) {
          message.filedata = this.fileData.url;
        } else {
          const reader = new FileReader();
          reader.onload = (e) => {
            message.filedata = e.target.result;

            this.sendWebSocketMessage(message);
          };
          reader.readAsDataURL(this.fileData.raw);
          return;
        }
      }

      this.sendWebSocketMessage(message);
    },

    sendWebSocketMessage(message) {
      if (this.socket && this.socket.readyState === WebSocket.OPEN) {
        this.socket.send(JSON.stringify(message));
        this.messageVal = "";
        this.clearPreview();
      } else {
        console.warn("WebSocket is not connected or not open.");
      }
    },

    getcountread() {
      if (this.socket && this.socket.readyState === WebSocket.OPEN) {
        const message = {
          type: "mark_as_read",
          message_ids: unreadIds,
        };
        console.log("message", message);

        this.socket.send(JSON.stringify(message));
      } else {
        console.warn("WebSocket is not connected or not open.");
      }
    },
  },
};
</script>

<style scoped>
.heightfix {
  height: calc(100vh - 170px) !important;
}
</style>
